export class Assistant {
    protected messages = [];
    protected toolCalls = [];
    protected toolResults = [];

    requiredAnotherChat = false;

    constructor() {
    }


    addSystemMessage(message) {

    }

    addUserMessage(message) {
    }

    addToolCall(functionId, functionName, functionArgs, functionResult) {
    }


    getFunctionCalls(): any {
        return null;
    }

    getFunctionList(result) {
        return null;
    }

    getPrompt() {

    }

}
